function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*
  placement: 'bottom',
  isButton: true/false (render as button or link)
  buttonProps: object (additional props to add to popover trigger)
  label: string, (required)
  msgComponent: Component (required, unless items sent. if both sent, defaults to msgComponent)
  items: [{ label, icon, clickEvent }] (required, unless msgComponent sent)
  id: id of trigger button (optional)
*/

import { renderToString } from 'react-dom/server';
import { useRef, useState } from 'react';
import styles from '../../../sass/apricot.module.scss';
function Popover(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var trigger = useRef(null);
  var items = props.items,
    label = props.label,
    _placement = props.placement,
    isButton = props.isButton,
    buttonProps = props.buttonProps,
    id = props.id;
  var getItems = function getItems(_ref) {
    var msgComponent = _ref.msgComponent,
      items = _ref.items;
    return msgComponent ? /*#__PURE__*/React.createElement("div", {
      className: "popover-content"
    }, /*#__PURE__*/React.createElement("msgComponent", null)) : /*#__PURE__*/React.createElement("ul", {
      className: "".concat(styles['popover-list'], " cb-popover-list")
    }, items.map(function (_ref2, i) {
      var label = _ref2.label,
        icon = _ref2.icon;
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        "data-index": i
      }, label, icon ? /*#__PURE__*/React.createElement("span", {
        className: "cb-glyph ".concat(icon),
        "aria-hidden": "true"
      }) : null));
    }));
  };

  // click event for menu items has to be done this way because of how bootstrap popovers work
  // the content for the dropdown menu is being rendered into a string
  // onClick events are lost when this happens
  var clickMenuEvent = function clickMenuEvent(e) {
    var element = e.target;
    var isPopoverItem = $(element).parents('.cb-popover-list').length > 0;
    if (isPopoverItem) {
      var _ref3 = items[element.dataset.index] || {},
        clickEvent = _ref3.clickEvent;
      if (clickEvent) {
        $(trigger.current).popover('hide');
        clickEvent(e);
      }
    }
  };
  useEffect(function () {
    var $trigger = $(trigger.current);
    $trigger.popover({
      html: true,
      content: function content() {
        return renderToString(getItems(props));
      },
      placement: function placement(context) {
        $(context).addClass(items ? 'cb-popover-list-content' : 'popover');
        return _placement || 'bottom';
      }
    }).cbPopOverListItems({
      focus: true
    });
    $trigger.on('hidden.bs.popover', function () {
      return setOpen(false);
    });
    $trigger.on('shown.bs.popover', function () {
      return setOpen(true);
    });
    document.addEventListener('click', clickMenuEvent);
    return function () {
      $trigger.off('hidden.bs.popover');
      $trigger.off('shown.bs.popover');
      document.removeEventListener('click', clickMenuEvent);
    };
  }, []);
  return /*#__PURE__*/React.createElement("a", _extends({
    href: "#",
    "data-container": "body",
    role: "button",
    ref: trigger,
    id: id,
    className: isButton ? 'btn btn-lg btn-primary cb-popover-button-list' : 'cb-popover-link-list',
    "data-toggle": "popover",
    type: "button"
  }, buttonProps), items ? /*#__PURE__*/React.createElement("span", {
    className: "cb-glyph cb-down pull-right",
    "aria-hidden": "true"
  }) : null, label);
}
export default Popover;